import { alert } from "lib/@dialogs/alert"
import { logUiEvent } from "routes/log/controller/log-event"

export function handleUnlicensedContent(item, e) {
    const isItemNotLicensed = item?.notLicensed || item.$?.notLicensed
    if (!isItemNotLicensed) return false

    e?.preventDefault?.()
    e?.stopPropagation?.()
    alert("You do not have a license for this content", "Not licensed").catch(console.error)
    const payload = { _id: item?._id, code: item?.code, label: item?.label }
    logUiEvent("unlicensed-content", payload)
    return true
}
